import React, { useEffect, useRef, useState } from 'react';
import styles from './deal.module.css';
import { textStyles } from '../../../constants/textStyles';
import HookForm from '../../../components/HookForm/HookForm';
import SelectClients from '../../../components/Selects/SelectClients';
import SelectDealStatuses from '../../../components/Selects/SelectDealStatuses';
import SelectPaymentTypes from '../../../components/Selects/SelectPaymentTypes';
import Modal from '../../../components/Modal/Modal';
import Cars from '../../Car/Cars';
import DealCreateCarsModal from './DealCreateCarsModal';
import CarCreate from '../../Car/NewCar/CarCreate';
import CarFixModal from '../../../components/Modals/CarFixModal';
import getCarMissingFields from '../../../utils/getCarMissingFields';
import SelectCreditPeriod from '../../../components/Selects/SelectCreditPeriod';
import DeleteButton from '../../../components/DeleteButton/DeleteButton';
import formatNumber from '../../../utils/formatNumber';
import ButtonEdit from '../../../components/Button/ButtonEdit';
import axios from 'axios';
import createDeal from '../../../api/deals/createDeal';
import { useLocation, useNavigate } from 'react-router-dom';
import editDeal from '../../../api/deals/editDeal';
import ButtonDelete from '../../../components/Button/ButtonDelete';
import removeItemsToDeal from '../../../api/deals/removeItemsToDeal';
import setStep from '../../../api/deals/setStep';
import addItemsToDeal from '../../../api/deals/addItemsToDeal';
import createNumberMask from '../../../utils/createNumberMask';
import SelectManager from '../../../components/Selects/SelectManager';
import LoaderInline from '../../../components/Loader/LoaderInline';
import { getErrorString } from '@microsoft/signalr/dist/esm/Utils';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import alert from '../../../helpers/alert';
import { useSelector } from 'react-redux';
import { ROLE_MANAGER, ROLE_MOP } from '../../../constants/roles';
import AddButton from '../../../components/AddButton/AddButton';
import ClientCreateModal from '../../../components/ClientCreateModal/ClientCreateModal';
import Select from '../../../components/Select/Select';
import { isConsignmentOrigin } from '../../../constants/carOrigin';
import getBuInfo from '../../../api/shop/buInfo';
import { consignmentSellerOf, sellerOptionOf } from './consignmentSeller';
import { defaultPaymentOption } from './greySteps';
import GreyDealCar from './GreyDealCar';
import getItems from '../../../api/cars/getItems';
import Button from '../../../components/Button/Button';
import BusyOverlay from '../../../components/Loader/BusyOverlay';
import { shortFormsEnabled } from '../../../brand/tenant';

const DEFAULT_MANAGER_ROLE_IDS = [ROLE_MANAGER, ROLE_MOP];

const DealCreationMainInfo = ({ nextStep, deal, cars, update }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const formRef = useRef(null);
  const [clientModal, setClientModal] = useState(false);

  const [car, setCar] = useState(cars);

  // У б/у авто по договору поручения продавец — клиент, подписавший поручение.
  // Поле информационное: менять его в сделке нельзя, оно определяется автомобилем.
  // Из флоу постановки продавец приезжает вместе с авто, при продаже из карточки —
  // дотягиваем из buInfo.
  const [fetchedSeller, setFetchedSeller] = useState(null);
  const passedSeller = car?.map((item) => consignmentSellerOf(item?.consignment)).find(Boolean);
  const consignmentSeller = passedSeller || fetchedSeller;

  // Продавец — такой же клиент из базы, как и покупатель, поэтому и показываем
  // его селектом, только заблокированным: выбирать нечего, он определён авто.
  // У серого дилера продавец — ДЦ, а не клиент: его id из другой таблицы, исключать по нему клиентов нельзя.
  const sellerOption = sellerOptionOf(consignmentSeller);
  const sellerIsClient = Boolean(consignmentSeller) && !consignmentSeller.isDc;

  useEffect(() => {
    if (passedSeller) return;
    const consignmentCar = car?.find((item) => isConsignmentOrigin(item?.originCarId));
    if (!consignmentCar?.id) {
      setFetchedSeller(null);
      return;
    }
    getBuInfo(consignmentCar.id)
      .then((res) => setFetchedSeller(consignmentSellerOf(res?.data?.consignment)))
      .catch(() => setFetchedSeller(null));
  }, [car, passedSeller]);

  const inputs = [
    {
      label: 'Клиент',
      name: 'clientId',
      component: SelectClients,
      // Продавец комиссионного авто не может быть в этой же сделке покупателем.
      excludeIds: sellerIsClient ? [sellerOption.value] : undefined,
      rules: {
        required: !deal,
      },
      defaultValue: deal
        ? { value: deal?.client?.id, label: `${deal?.client?.name} ${deal?.client?.surname}` }
        : location?.state?.client
        ? {
            value: location?.state?.client?.id,
            label: `${location?.state?.client?.name} ${location?.state?.client?.surname}`,
          }
        : null,
    },
    {
      // Клиента можно завести не уходя со сделки — модалка отдаёт готовую опцию,
      // которую сразу подставляем в селект выше.
      name: 'addClient',
      component: AddButton,
      text: 'Добавить клиента',
      onClick: (e) => {
        e.preventDefault();
        setClientModal(true);
      },
    },
    {
      label: 'Способ оплаты',
      name: 'paymentTypeId',
      component: SelectPaymentTypes,
      rules: {
        required: !deal,
      },
      defaultValue: deal ? { value: deal?.paymentType?.id, label: deal?.paymentType?.title } : defaultPaymentOption(),
    },

    {
      label: 'Ответственный менеджер',
      name: 'managerId',
      component: SelectManager,
      rules: {
        required: true,
      },
      defaultValue: DEFAULT_MANAGER_ROLE_IDS.includes(user?.roleId)
        ? {
            value: user?.id,
            label: `${user?.name} ${user?.surname}`,
          }
        : null,
    },

    // {
    //   label: 'Первоначальный взнос',
    //   name: 'initialFee',
    //   dependency: ['paymentTypeId', 'car'],
    //   dependencyAccessor: (obj) => obj[0]?.value,
    //   placeholder: 'Введите первоначальный взнос',
    //   isCredit: true,
    //   hide: () => !car?.length,
    //   mask: createNumberMask({
    //     allowDecimal: true,
    //     prefix: '',
    //     thousandsSeparatorSymbol: ' ',
    //     decimalLimit: 0,
    //   }),
    //   rules: {
    //     valueAsNumber: true,
    //     validate: (value, getValues) => {
    //       value = value?.replace(/\s/g, '');
    //       value = parseInt(value);
    //       if (!car?.length) return true;
    //       const paymentTypeId = getValues('paymentTypeId');
    //       if (paymentTypeId?.value !== 6 && paymentTypeId?.value !== 7) {
    //         return true;
    //       }

    //       let error = true;
    //       const carPrice = car?.reduce((acc, item) => acc + item?.price, 0);
    //       if (value < (carPrice * 0.1)?.toFixed(0)) {
    //         error = `Минимальная сумма взноса 10% от стоимости автомобиля`;
    //       } else if (value > carPrice) {
    //         error = 'Сумма взноса не может превышать стоимость автомобиля';
    //       } else if (isNaN(value)) {
    //         error = 'Поле обязательно для заполнения';
    //       } else {
    //         error = true;
    //       }

    //       return error;
    //     },
    //   },
    // },
    // {
    //   label: 'Срок кредитования, месяцев',
    //   name: 'period',
    //   component: SelectCreditPeriod,
    //   dependency: 'paymentTypeId',
    //   dependencyAccessor: (obj) => obj?.value,
    //   hide: () => !car?.length,
    //   rules: {
    //     deps: ['paymentTypeId', 'car'],
    //     validate: (value, getValues) => {
    //       if (!car?.length) return true;
    //       const paymentTypeId = getValues('paymentTypeId');
    //       let error = true;

    //       if (!value && (paymentTypeId?.value === 6 || paymentTypeId?.value === 7)) {
    //         error = 'Поле обязательно для заполнения';
    //       } else {
    //         error = true;
    //       }

    //       return error;
    //     },
    //   },
    // },
  ];
  const [carsModal, setCarsModal] = useState(false);
  const openCarsModal = () => {
    setCarsModal(true);
  };

  const [fixQueue, setFixQueue] = useState([]);

  // Авто заводят прямо из окна выбора: форма создания открывается поверх сделки, а созданное авто
  // сразу попадает в неё — данные сделки не теряются.
  const [addCarModal, setAddCarModal] = useState(false);
  const onCarCreatedInline = (created) => {
    setAddCarModal(false);
    onCarsFormSubmit([...(car || []).filter((item) => item.id !== created.id), created]);
  };

  const onCarsFormSubmit = (cars) => {
    const currentYear = new Date().getFullYear();
    const problematicCars = cars.filter(car => car.issueYear > currentYear || isNaN(car.issueYear) || car.issueYear < 1900);
    if (problematicCars.length > 0) {
      return alert.error(`Проверьте год выпуска авто ${problematicCars.map(car => `${car.mark} ${car.model} (${car.vin})`).join(', ')}.`);
    }

    // Объём двигателя уходит в банки: они ищут машину в справочнике по марке,
    // модели, году и объёму сразу. Пустой объём ловится ниже как обязательное поле,
    // а неверный виден только по расхождению с комплектацией — предупреждаем здесь,
    // потому что на шаге выбора банков заявка уже уходит и приходит отказ Форте.
    const wrongVolume = cars.filter((car) => car.engineVolumeWarning);
    if (wrongVolume.length > 0) {
      wrongVolume.forEach((car) =>
        alert.error(`${car.mark} ${car.model}: ${car.engineVolumeWarning}`, {
          autoClose: false,
          closeOnClick: false,
        })
      );
    }

    const checked = cars.map((car) => ({ car, missing: getCarMissingFields(car) }));
    const ready = checked.filter((item) => item.missing.length === 0).map((item) => ({ ...item.car, n: true }));
    const incomplete = checked.filter((item) => item.missing.length > 0);

    setCarsModal(false);
    setCar(ready);

    if (incomplete.length > 0) {
      setFixQueue(incomplete);
      alert.error(
        `${incomplete.length > 1 ? 'У некоторых автомобилей' : 'У автомобиля'} не заполнены обязательные поля. Заполните их в открывшемся окне, чтобы добавить ${
          incomplete.length > 1 ? 'их' : 'его'
        } в сделку.`
      );
    }
  };

  const handleCarFixed = (updatedCar) => {
    const missing = getCarMissingFields(updatedCar);
    if (missing.length > 0) {
      setFixQueue((prev) => {
        if (!prev.length) return prev;
        const [, ...rest] = prev;
        return [{ car: updatedCar, missing }, ...rest];
      });
      return;
    }

    setCar((prev) => {
      const existing = prev || [];
      if (existing.some((item) => item.id === updatedCar.id)) return existing;
      return [...existing, { ...updatedCar, n: true }];
    });
    alert.success(`Автомобиль ID${updatedCar?.id} добавлен в сделку`);
    setFixQueue((prev) => prev.slice(1));
  };

  const handleSkipFix = () => {
    const current = fixQueue[0];
    if (current) {
      alert.error(`Автомобиль ID${current.car?.id} не добавлен в сделку — данные не заполнены.`);
    }
    setFixQueue((prev) => prev.slice(1));
  };

  const handleSubmit = (values, carsOverride) => {
    const dealCars = carsOverride || car;
    setLoading(true);
    console.log(values);
    const payload = {
      deal: {
        ...values,
        clientId: values?.clientId?.value,
        statusId: values?.statusId?.value,
        paymentTypeId: values?.paymentTypeId?.value,
        managerId: values?.managerId?.value,
      },
      options: {
        cars: dealCars?.map((item) => ({ value: item.id })),
        clientId: values?.clientId?.value,
      },
    };

    // if (values?.paymentTypeId?.value === 6 || values?.paymentTypeId?.value === 7) {
    //   values.initialFee = values?.initialFee?.replace(/\s/g, '');
    //   values.initialFee = parseInt(values?.initialFee);
    //   payload.credit = {
    //     period: Number(values?.period?.value),
    //     initialFee: values?.initialFee,
    //   };
    // }
    if (deal?.id) {
      editDeal({
        clientId: values?.clientId?.value || deal?.client?.id,
        statusId: values?.statusId?.value,
        paymentTypeId: values?.paymentTypeId?.value,
        id: deal?.id,
        dealId: deal?.id,
      })
        .then(() => {
          if (dealCars?.filter((item) => item?.n)?.length) {
            addItemsToDeal({
              cars: dealCars?.map((item) => ({ value: String(item.id) })),
              dealId: String(deal?.id),
              step: 2,
              clientId: values?.clientId?.value || deal?.client?.id,
            })
              .then(() => {
                nextStep();
              })
              .catch((err) => alert(err));
          } else {
            setStep({ dealId: String(deal?.id), step: 2 }).then(() => {
              update();
            });
          }
        })
        .finally(() => setLoading(false));
    } else {
      createDeal(payload)
        .then((res) => {
          nextStep(res?.data);
          navigate(`/deals/deal/${res?.data}/main-info`);
        })
        .catch((err) => {
          alert.error(extractErrorMessage(err?.data) || 'Произошла ошибка при создании сделки');
        })
        .finally(() => setLoading(false));
    }
  };

  const handleCarDelete = (item) => {
    if (item?.n) {
      const newCars = car.filter((car) => car.id !== item.id);
      console.log(newCars);
      setCar(newCars);
    } else {
      removeItemsToDeal({
        cars: [{ value: String(item?.orderId) }],
        dealId: String(deal?.id),
      }).then(() => {
        update();
      });
    }
  };

  useEffect(() => {
    setCar(cars);
  }, [cars]);

  useEffect(() => {
    if (location?.state?.car) {
      onCarsFormSubmit([location?.state?.car]);
    }
  }, [location]);

  const [touched, setTouched] = useState(false);

  // Серый дилер: машину не ищут в каталоге, а вводят VIN — найденную выбирают, ненайденную тут же заводят.
  const grey = shortFormsEnabled();
  const greyCarRef = useRef(null);
  // Что сейчас делаем до создания сделки (проверка, заведение авто); сам запрос сделки показывается через loading.
  const [busy, setBusy] = useState('');

  const pickGreyCar = async (found) => {
    const res = await getItems({ id: found.id }).catch(() => null);
    const full = res?.data?.cars?.[0];
    if (!full) {
      alert.error('Не удалось загрузить автомобиль — попробуйте ещё раз');
      return;
    }
    onCarsFormSubmit([full]);
  };

  // Одна кнопка на всё: проверили основную форму, при новом VIN заводим авто и сразу создаём сделку с ним.
  const submitGrey = async () => {
    const values = await formRef.current?.submit();
    if (!values) return;
    if (car?.length) {
      setTouched(false);
      handleSubmit(values);
      return;
    }
    setBusy('Проверяем автомобиль…');
    // VIN введён целиком и такая машина уже есть, хотя её не выбрали, — подтягиваем её и продолжаем.
    const existing = await greyCarRef.current?.findExisting();
    if (existing) {
      const res = await getItems({ id: existing.id }).catch(() => null);
      const full = res?.data?.cars?.[0];
      if (!full) {
        setBusy('');
        alert.error('Не удалось загрузить автомобиль — попробуйте ещё раз');
        return;
      }
      // Не хватает данных для сделки — тот же путь, что и при выборе: окно дозаполнения, продолжить можно после него.
      if (getCarMissingFields(full).length > 0) {
        setBusy('');
        onCarsFormSubmit([full]);
        return;
      }
      const ready = [{ ...full, n: true }];
      setCar(ready);
      setTouched(false);
      setBusy('');
      handleSubmit(values, ready);
      return;
    }
    if (greyCarRef.current?.hasNewCar()) {
      setBusy('Добавляем автомобиль…');
      const created = await greyCarRef.current.submitNewCar();
      if (!created) {
        setBusy('');
        return;
      }
      const ready = [{ ...created, n: true }];
      setCar(ready);
      setTouched(false);
      setBusy('');
      handleSubmit(values, ready);
      return;
    }
    setBusy('');
    setTouched(true);
  };

  // Клиента могли выбрать до того, как в сделку добавили его же авто — из списка
  // он уже отфильтрован, но выбранным остался. Снимаем выбор и говорим почему:
  // молча пропавшее заполненное поле выглядит как баг.
  useEffect(() => {
    if (!sellerIsClient) return;
    if (formRef.current?.getValues('clientId')?.value !== sellerOption.value) return;
    formRef.current.setValue('clientId', null);
    alert.error('Продавец автомобиля не может быть покупателем в этой же сделке');
  }, [sellerOption?.value]);

  return (
    <>
      {/* <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>Основная информация о сделке</p> */}
      <HookForm
        ref={formRef}
        inputs={inputs}
        title={'Основная информация о сделке'}
        // У серых блок автомобиля идёт сразу под формой: нижние отступы формы обнуляем, иначе между ними пустота.
        style={grey ? { marginBottom: 0, paddingBottom: 0 } : undefined}
        grid={grey ? { display: 'grid', gap: 20, marginBottom: 0 } : { display: 'grid', gap: 20 }}
        onSubmit={(values) => {
          if (car?.length) {
            setTouched(false);
            handleSubmit(values);
          } else {
            setTouched(true);
          }
        }}
        action={grey ? undefined : 'Сохранить и продолжить'}
        customData={
          grey
            ? undefined
            : () =>
          car?.length ? (
            <div style={{ display: 'grid', gap: 20 }}>
              {sellerOption && (
                <Select
                  title="Продавец"
                  hint="Собственник автомобиля по договору поручения. Определяется автомобилем, в сделке не меняется."
                  options={[sellerOption]}
                  value={sellerOption}
                  disabled
                />
              )}
              <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '0 20px', alignItems: 'center' }}>
                <p>Автомобиль:</p>
                {car.map((car) => {
                  return (
                    <div
                      key={car.id}
                      style={{
                        gridColumn: '2/2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      ID{car?.id} {car?.mark} {car?.model} {car?.complectation?.title} {car?.issueYear}{' '}
                      {car?.price ? '(' + formatNumber(car?.price) + ' ₸)' : ''}{' '}
                      <ButtonDelete onClick={() => handleCarDelete(car)} />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null
        }
        addCustomItemTitle={grey ? undefined : 'Добавить автомобили'}
        handleAddCustomItem={openCarsModal}
        error={grey || car?.length > 0 || !touched ? false : 'Добавьте автомобиль'}
        loading={loading}
      />
      {grey && (busy || loading) && <BusyOverlay text={busy || 'Создаём сделку…'} />}
      {grey && (
        <>
          <GreyDealCar
            ref={greyCarRef}
            cars={car}
            onPick={pickGreyCar}
            onRemove={handleCarDelete}
            error={touched && !car?.length ? 'Введите VIN автомобиля' : ''}
          />
          <div style={{ padding: '0 20px 20px' }}>
            <Button text="Сохранить и продолжить" fill onClick={submitGrey} disabled={loading} />
          </div>
        </>
      )}
      <ClientCreateModal
        isOpen={clientModal}
        onRequestClose={() => setClientModal(false)}
        onCreated={(option) => formRef.current?.setValue('clientId', option)}
      />
      <DealCreateCarsModal
        isOpen={carsModal}
        onRequestClose={() => setCarsModal(false)}
        onSubmit={onCarsFormSubmit}
        onCancel={() => setCarsModal(false)}
        onAddCar={() => setAddCarModal(true)}
      />
      <Modal isOpen={addCarModal} onRequestClose={() => setAddCarModal(false)}>
        <CarCreate onCreated={onCarCreatedInline} />
      </Modal>
      <CarFixModal
        isOpen={fixQueue.length > 0}
        car={fixQueue[0]?.car}
        missingFields={fixQueue[0]?.missing}
        remainingCount={fixQueue.length}
        onFixed={handleCarFixed}
        onSkip={handleSkipFix}
      />
    </>
  );
};

export default DealCreationMainInfo;
